export const COUNTRIES_RESET_STATE = 'COUNTRIES_RESET_STATE';
export const COUNTRIES_CURRENT_ITEM = 'COUNTRIES_CURRENT_ITEM';
 
export const COUNTRIES_REQUEST_LOADING = 'COUNTRIES_REQUEST_LOADING';
export const COUNTRIES_REQUEST_SUCCESS = 'COUNTRIES_REQUEST_SUCCESS';
export const COUNTRIES_REQUEST_FAILED = 'COUNTRIES_REQUEST_FAILED';
 
export const COUNTRIES_CURRENT_ACTION = 'COUNTRIES_CURRENT_ACTION';
export const COUNTRIES_RESET_ACTION = 'COUNTRIES_RESET_ACTION';